import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loadMember, loadMemberForCongress, loadMemberList, loadPartyVoteStats } from '../actions'

const DEFAULT_CONGRESS = 117;

const RouteChange = withRouter(({ location, history }) => {
  const dispatch = useDispatch();
  const MEMBER_PATH = 'members';
  const MEMBER_SEARCH_PATH = 'member-search';

  useEffect(() => {
	  const searchParams = new URLSearchParams(location.search);
	  const parentUrl = searchParams.get("parentUrl");

	  if (parentUrl) {
		const parentPath = parentUrl.split("/");
		dispatch(loadPartyVoteStats());

		if (parentPath.includes(MEMBER_PATH)) {
			const memberId = parentPath[parentPath.length-2];
			if (isNaN(memberId)) {
				history.replace("/member-search/" + DEFAULT_CONGRESS);
			} else {
				dispatch(loadMemberForCongress(parentPath[parentPath.length-2], DEFAULT_CONGRESS));
			}
		} else if (parentPath.includes(MEMBER_SEARCH_PATH)) {
			dispatch(loadMemberList(DEFAULT_CONGRESS));
		} else {
			const embeddedPath = location.pathname.split("/");
			dispatch(loadMember(embeddedPath[embeddedPath.length-1]));
		}
	  } else {
		const path = location.pathname.split("/");
		console.log("Path->", path);
		debugger;

		if (2 === path.length) {
			dispatch(loadMemberList(DEFAULT_CONGRESS));
		}
		if (3 === path.length && MEMBER_SEARCH_PATH === path[1]) {
			dispatch(loadMemberList(path[2]));
		}
		if (3 === path.length && MEMBER_PATH === path[1]) {
			dispatch(loadPartyVoteStats());
			dispatch(loadMemberForCongress(path[2], DEFAULT_CONGRESS));
		}
	  }
  });

  return null;
});

export default RouteChange;